<template>
  <van-uploader
    ref="uploader"
    v-model="files"
    :class="_.upload"
    :after-read="handleUpload"
    :max-count="limit"
    :multiple="true"
    @delete="handleDelete"
    @click-preview="isPreview = true"
    @close-preview="isPreview = false"
  >
    <div :class="[_.uploader, 'van-uploader__preview-image']">
      <img :src="require('./images/照片.png')" :class="_.icon" />
      <div :class="_.tips">
        <div>{{ placeholder }}</div>
        <div>（最多{{ limit }}张）</div>
      </div>
    </div>
  </van-uploader>
</template>

<script>
  import Vue from 'vue'
  import { apiSaleAfterStandardEcommerceSaleAfterUploadPic } from '@/api'
  import { castArray, wait } from 'vtils'
  import { FileData } from 'yapi-to-typescript'
  import { newRouteOnValueChange } from '@/utils'

  export default Vue.extend({
    props: {
      value: {
        type: Array,
        required: true,
      },
      placeholder: {
        type: String,
        required: true,
      },
      limit: {
        type: Number,
        required: true,
      },
    },

    data: () => ({
      files: [],
      isPreview: false,
    }),

    watch: {
      value: {
        immediate: true,
        handler(value) {
          const files = this.files.slice()
          value.forEach((url, index) => {
            if (!files[index]) {
              files[index] = { url }
            }
            if (files[index].url !== url) {
              files[index].url = url
            }
          })
          this.files = files
        },
      },
    },

    mounted() {
      newRouteOnValueChange({
        ctx: this,
        valueName: 'isPreview',
        callback: v => {
          if (!v) {
            this.$refs.uploader.closeImagePreview()
          }
        },
      })
    },

    methods: {
      async handleUpload(file) {
        await Promise.all(
          castArray(file).map(async file => {
            file.status = 'uploading'
            file.message = '上传中...'
            try {
              const { url } =
                await apiSaleAfterStandardEcommerceSaleAfterUploadPic(
                  {
                    // 上传 file.file
                    file: new FileData(file.file),
                  },
                  {
                    timeout: 100000,
                  },
                )
              file.content = undefined
              file.url = url
              file.status = 'done'
              file.message = '上传成功'
            } catch {
              file.status = 'failed'
              file.message = '上传失败'
              await wait(1000)
              this.$delete(this.files, this.files.indexOf(file))
            }
            this.$emit(
              'input',
              this.files.map(file => file.url),
            )
          }),
        )
      },
      handleDelete() {
        this.$emit(
          'input',
          this.files.map(file => file.url),
        )
      },
    },
  })
</script>

<style lang="scss" module>
  .upload {
    :global {
      .van-uploader__preview {
        border-radius: 4px;
        overflow: hidden;
      }
    }

    .uploader {
      background: #f5f6f8;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 4px;

      .icon {
        width: 29px;
        height: 24px;
      }

      .tips {
        margin-top: 8px;
        font-size: 12px;
        color: #888888;
      }
    }
  }
</style>
